module.exports = __webpack_public_path__ + "static/hankyung-91668bdd3020dc6e2c2f09d1dcea6e5c.png";